import React, { useContext, useRef, useEffect, useState } from "react";
import { NavLink, Link, useHistory, useLocation } from "react-router-dom";
import GlobalContext from "../../../context/GlobalContext";
import useToggle from "../../../utils/useToggle";
import useWidth from "../../../utils/useWidth";
import MobileLinks from "./MobileLinks";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import "./Header.css";
import isAuthenticate from "../../../utils/auth";
import { ModalContext } from "../../../context/ModalContext";
import Login from "../../../Themes/Theme1/Login";
import Signup from "../../../Themes/Theme1/Signup";
import RegisterBidPop from "../../../Themes/Theme1/Signup/RegisterBidPop";
import SearchBar from "../../atoms/SearchBar";
import CustomDrawer from "../CustomDrawer";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: "2px 8px",
    width: "275px",
  },
  mobileFormControl: {
    margin: theme.spacing(1),
    width: "163px",
    marginBottom: "5px",
  },
  formControldiv: {
    width: "300px",
  },
  mobileFormControldiv: {
    width: "170px",
    marginBottom: "3px",
  },
}));

const Header = ({ store_data }) => {
  const ref = useRef(null);
  const [width] = useWidth(ref);
  const location = useLocation();
  const history = useHistory();
  const classes = useStyles();
  const { userDetails } = useContext(GlobalContext);
  const { isLoginOpen, isSignupOpen, isRegisterToBidOpen } =
    useContext(ModalContext);
  const [menu, toggleMenu] = useToggle(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const isHome = location.pathname === "/";
  const isSearchPage = location.pathname.includes("/search");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    if (!isHome) return;
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHome]);
  const headerClass = isHome
    ? isScrolled
      ? "headerScrolled"
      : "headerTransparent"
    : "headerScrolled";

  const handleUpdateClick = (id, email) => {
    history.push({
      pathname: `/signup`,
      state: {
        action: "userUpdate",
        user_id: id,
        values: { email },
      },
    });
  };
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const logoSrc =
    windowWidth <= 990
      ? "/images/nextDoor.svg"
      : isHome && !isScrolled
        ? "/images/nextDoorWhite.svg"
        : "/images/nextDoor.svg";
  return (
    <>
      <div className="header-container">
        <header ref={ref} className={`header-warpper-beforelg ${headerClass}`}>
          <div className={`${isSearchPage ? "" : "container extendWidth"}`}>
            <nav className="navbar navbar-expand-lg" role="navigation">
              <div className="navbar-header d-lg-block">
                {window.location.pathname.includes("/search") ||
                window.location.pathname.includes("/auctions") ? (
                  <CustomDrawer
                    anchor="top"
                    customClass="searchBarChange"
                    buttonLabel={<span className="material-icons">search</span>}
                    drawerClass="search-top"
                  >
                    <div className="search-input-wrap">
                      <FormControl
                        variant="outlined"
                        className={`${
                          !width
                            ? classes.mobileFormControl
                            : classes.formControl
                        } headerSpecial`}
                      >
                        <SearchBar from="header" fullWidth={true} />
                      </FormControl>
                    </div>
                  </CustomDrawer>
                ) : null}
              </div>
              <Link
                className={
                  window.location.pathname.includes("/search") ||
                  window.location.pathname.includes("/auctions")
                    ? "navbar-brand"
                    : "navbar-brand ml-0"
                }
                to={`/`}
              >
                <img
                  className="img-responsive hm-logo f"
                  src={logoSrc}
                  alt="Next Door Auction"
                />
              </Link>
              {/* {window.location.pathname.includes("/search") ||
              window.location.pathname.includes("/auctions") ? (
                <div className="mobileViewTest w-100">
                  <FormControl
                    variant="outlined"
                    className={`${
                      !width ? classes.mobileFormControl : classes.formControl
                    } headerSpecial`}
                  >
                    <SearchBar from="header" fullWidth={true} />
                  </FormControl>
                </div>
              ) : null} */}
              {window.location.pathname === "/search" ? (
                <div className="mobileViewTest w-100">
                  <FormControl
                    variant="outlined"
                    className={`${
                      !width ? classes.mobileFormControl : classes.formControl
                    } headerSpecial`}
                  >
                    <SearchBar from="header" fullWidth={true} />
                  </FormControl>
                </div>
              ) : null}
              <MobileLinks width={width} store_data={store_data} menu={menu} />
            </nav>
          </div>
        </header>
      </div>

      {!window.location.pathname.includes("/property") && (
        <>
          {isAuthenticate() && userDetails.get["status"] === "incomplete" && (
            <div
              className={`${
                window.location.pathname.includes(`/search`) ? "srchPdg" : ""
              } usrRegCheck`}
            >
              <p>
                Your account is incomplete, please{" "}
                <a
                  onClick={() =>
                    handleUpdateClick(
                      userDetails.get["id"],
                      userDetails.get["email"],
                    )
                  }
                >
                  click here
                </a>{" "}
                to update your account info
              </p>
            </div>
          )}
        </>
      )}

      {isLoginOpen && <Login />}
      {isSignupOpen && <Signup />}

      {isRegisterToBidOpen && <RegisterBidPop />}
    </>
  );
};

export default Header;
